"use client"

import { Navigate, useLocation } from "react-router"

/**
 * Old bookmarks / hard-coded Clinical Education (Prism) URLs for Exam
 * Management surfaces → canonical `/exam-management/...` product root.
 */
export function RedirectPrismExamManagement({
  segment,
}: {
  segment: string
}) {
  const { pathname, search, hash } = useLocation()
  const prefix = `/prism/${segment}`
  const rest = pathname.startsWith(prefix) ? pathname.slice(prefix.length) : ""
  return (
    <Navigate
      to={`/exam-management/${segment}${rest}${search}${hash}`}
      replace
    />
  )
}
